import Vue from 'vue';
import RoHeader from './RoHeader';
import RoHeaderBurger from './RoHeaderBurger';

Vue.component('ro-header', RoHeader);
Vue.component('ro-header-burger', RoHeaderBurger);

export default RoHeader;



// WEBPACK FOOTER //
// ./scripts/ro-header/index.js